var _defs, _circle, _path, _circle2, _path2, _path3, _circle3, _path4, _circle4, _line, _line2, _path5, _circle5, _path6, _circle6, _line3, _line4, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamDiscussIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "scaling-svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 172 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".teamdiscussicon01-cls-1{fill:#ccebf8;}.teamdiscussicon01-cls-2,.teamdiscussicon01-cls-4{fill:none;}.teamdiscussicon01-cls-2{stroke:#000;stroke-miterlimit:10;}.teamdiscussicon01-cls-2,.teamdiscussicon01-cls-3,.teamdiscussicon01-cls-4{stroke-width:2px;}.teamdiscussicon01-cls-3{fill:#fff;}.teamdiscussicon01-cls-3,.teamdiscussicon01-cls-4{stroke:#707070;stroke-linecap:round;stroke-linejoin:round;}.teamdiscussicon01-cls-5{fill:#707070;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "teamdiscussicon01-cls-1",
    cx: 87,
    cy: 65,
    r: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "teamdiscussicon01-cls-1",
    d: "M118,123V102a16,16,0,0,0-16-16H72a16,16,0,0,0-16,16v21"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "teamdiscussicon01-cls-2",
    cx: 87,
    cy: 65,
    r: 14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "teamdiscussicon01-cls-2",
    d: "M118,123V102a16,16,0,0,0-16-16H72a16,16,0,0,0-16,16v21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "teamdiscussicon01-cls-3",
    d: "M1,139c0-10.49,38.06-19,85-19s85,8.51,85,19"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "teamdiscussicon01-cls-1",
    cx: 133,
    cy: 81,
    r: 14
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "teamdiscussicon01-cls-1",
    d: "M164,139V118a16,16,0,0,0-16-16H118a16,16,0,0,0-16,16v21"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "teamdiscussicon01-cls-2",
    cx: 133,
    cy: 81,
    r: 14
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "teamdiscussicon01-cls-2",
    x1: 117,
    y1: 123,
    x2: 117,
    y2: 139
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "teamdiscussicon01-cls-2",
    x1: 148,
    y1: 123,
    x2: 148,
    y2: 139
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "teamdiscussicon01-cls-2",
    d: "M164,139V118a16,16,0,0,0-16-16H118a16,16,0,0,0-16,16v21"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "teamdiscussicon01-cls-1",
    cx: 40,
    cy: 81,
    r: 14
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "teamdiscussicon01-cls-1",
    d: "M71,139V118a16,16,0,0,0-16-16H25A16,16,0,0,0,9,118v21"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "teamdiscussicon01-cls-2",
    cx: 40,
    cy: 81,
    r: 14
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "teamdiscussicon01-cls-2",
    x1: 24,
    y1: 123,
    x2: 24,
    y2: 139
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "teamdiscussicon01-cls-2",
    x1: 55,
    y1: 123,
    x2: 55,
    y2: 139
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "teamdiscussicon01-cls-2",
    d: "M71,139V118a16,16,0,0,0-16-16H25A16,16,0,0,0,9,118v21"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "teamdiscussicon01-cls-4",
    d: "M113,27H86.4V40l-10-13H62a8,8,0,0,1-8-8V9a8,8,0,0,1,8-8h51a8,8,0,0,1,8,8V19A8,8,0,0,1,113,27Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "teamdiscussicon01-cls-5",
    d: "M78.15,13.71a1.51,1.51,0,0,1,1.41-1.61h.12a1.61,1.61,0,1,1-1.53,1.69Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "teamdiscussicon01-cls-5",
    d: "M86,13.71a1.51,1.51,0,0,1,1.41-1.61h.12A1.61,1.61,0,1,1,86,13.79Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "teamdiscussicon01-cls-5",
    d: "M93.8,13.71a1.51,1.51,0,0,1,1.41-1.61h.12a1.61,1.61,0,1,1-1.53,1.69Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "teamdiscussicon01-cls-3",
    d: "M105,43h26.6V56l10-13H156a8,8,0,0,0,8-8V25a8,8,0,0,0-8-8H105a8,8,0,0,0-8,8V35a8,8,0,0,0,8,8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "teamdiscussicon01-cls-5",
    d: "M121.15,29.72a1.51,1.51,0,0,1,1.42-1.6h.11a1.61,1.61,0,1,1-1.53,1.69Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "teamdiscussicon01-cls-5",
    d: "M129,29.72a1.51,1.51,0,0,1,1.42-1.6h.11A1.61,1.61,0,1,1,129,29.81Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "teamdiscussicon01-cls-5",
    d: "M136.8,29.72a1.51,1.51,0,0,1,1.42-1.6h.11a1.61,1.61,0,0,1,0,3.21,1.5,1.5,0,0,1-1.53-1.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamDiscussIcon);
export default __webpack_public_path__ + "static/media/team-discuss-icon.6a12098d9573b792384be7dded39c5f8.svg";
export { ForwardRef as ReactComponent };